import angular from 'angular';
import uiRouter from 'angular-ui-router';
import affiliatesComponent from './affiliates.component';

let affiliatesModule = angular.module('app.containers.affiliates', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('affiliates', {
      url: '/affiliates',
      template: '<affiliates></affiliates>'
    });
})

.component('affiliates', affiliatesComponent);

export default affiliatesModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/affiliates/affiliates.js
 **/